/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Kind_OcopInputs */

const vi_shop_home_kind_ocop = /** @type {(inputs: Shop_Home_Kind_OcopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối OCOP`)
};

/**

* @param {Shop_Home_Kind_OcopInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_kind_ocop = /** @type {((inputs?: Shop_Home_Kind_OcopInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Kind_OcopInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_kind_ocop(inputs)
});